/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';
export const GET_MY_CREDENTIAL_LIST = gql`
query GetMyCredentials($input: GetListOfCredentialInput, $filter: UniqStudPortfolioFilterInput!) {
  getMyCredentials(input: $input) {
    data
    currentPage
    pageSize
    totalCount
    totalPages
  }
  getMyStudenPortfolioPerCredSchema(filter: $filter) {
    data {
      id
      _id
      name
      logo
      description
      jsonFormat
      jsonldFormat
      selfAttested
      credentials
    }
    currentPage
    pageSize
    totalCount
    totalPages
  }
}
  
`;
